import React from 'react';

import { Box, HStack, Heading, Icon, IconName, Text, VStack } from '@betterment/samba-react';

type Benefit = {
  icon: IconName;
  title: string;
  description: string;
};

const BENEFITS: Benefit[] = [
  {
    icon: 'Bank',
    title: 'Find your old account easily',
    description:
      'Quickly search and connect to your previous provider, even if you’re not sure where your account is now.',
  },
  {
    icon: 'People',
    title: 'Get support at every step',
    description:
      'Capitalize’s team coordinates your rollover, answers questions, and keeps you updated as your assets move over.',
  },
  {
    icon: 'Lock',
    title: 'Keep your data secure',
    description: 'Your data stays only at Betterment once your rollover is complete.',
  },
];

const BenefitRow: React.FC<Benefit> = ({ icon, title, description }) => (
  <HStack
    css={{
      gap: 'space.200',
      justifyItems: 'center',
      alignItems: 'center',
    }}
  >
    <Icon name={icon} size="medium" />
    <VStack
      css={{
        width: '100%',
        alignItems: 'start',
        justifyContent: 'center',
      }}
    >
      <Heading color="text" variant="title100">
        {title}
      </Heading>
      <Text color="text.weak" variant="text100">
        {description}
      </Text>
    </VStack>
  </HStack>
);

export const FlowOverviewPage: React.FC = () => {
  return (
    <Box
      css={{
        display: 'grid',
        gap: 'space.400',
      }}
    >
      {BENEFITS.map(benefit => (
        <BenefitRow key={benefit.title} icon={benefit.icon} title={benefit.title} description={benefit.description} />
      ))}
    </Box>
  );
};

export default FlowOverviewPage;
